import React, { Component } from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import ReservationsCarTable from './AvailableCars/ReservationsCarTable';
import ReservationsPersonal from './Personal/ReservationsPersonal';
import grey from '@material-ui/core/colors/grey';
import { FONT_FAMILY_TYPOGRAPHY } from '../../Utils/Constants';


const petrolBluePalette = createMuiTheme({
  palette: {
    primary: {
      light: '#7ba2ab',
      main: '#004A5D',
      dark: '#003341',
      contrastText: '#ffffff'
    },
    secondary: grey,
  },
  typography: FONT_FAMILY_TYPOGRAPHY
});


export class ReservationsContent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      newReservation: false,
      newCancellation: false
    };
  }

  detectReservation = () => {
    this.setState({ newReservation: !this.state.newReservation });
  };

  detectCancellation = () => {
    this.setState({ newCancellation: !this.state.newCancellation });
  };


  render() {

    return (
      <MuiThemeProvider theme={petrolBluePalette}>
        <ReservationsCarTable detectReservation={this.detectReservation.bind(this)} newCancellation={this.state.newCancellation} />
        <ReservationsPersonal detectCancellation={this.detectCancellation.bind(this)} newReservation={this.state.newReservation} />
      </MuiThemeProvider>
    )

  }
}

export default ReservationsContent;


// WEBPACK FOOTER //
// ./src/components/Reservations/ReservationsContent.js